import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  getStudentTotalCreditAmountToPay,
  getCreditTopUpAmount
} from "state/school_money/selectors";
import {
  addCreditTopUpToBasket,
  removeCreditTopUpFromBasket
} from "state/school_money/actions";

import Card from "components/Card";
import Currency from "components/Currency";
import AddOrRemoveButton from "components/school_money/AddOrRemoveButton";

class UnpaidClubMoneyPayment extends React.Component {

  addToBasket = () => {
    this.props.addToBasket("club_extended_services", this.props.studentID, this.props.arrearsAmount);
  }

  removeFromBasket = () => {
    this.props.removeFromBasket("club_extended_services", this.props.studentID);
  }

  render() {

    const { studentID, arrearsAmount, isInBasket } = this.props;

    if (arrearsAmount <= 0) {
      return null;
    }

    const linkPath = `/school_money/history/${studentID}/`;

    return (
      <div className="payment">
        <Card>
          <Card.Body>
            <div className="payment-header">
              <div className="payment-header__details">
                <div className="payment-header__text">
                  <div className="payment-header__description">
                    <Link to={linkPath}>Unpaid Club Money</Link>
                  </div>
                  <div className="payment-header__annotation">Tap to view history</div>
                </div>
                <div className="payment-header__controls">
                  <div className="payment-header__price">
                    <Currency amount={arrearsAmount} />
                  </div>
                  <AddOrRemoveButton
                    cssBlockName="payment-header"
                    isAdded={isInBasket}
                    onRemove={this.removeFromBasket}
                    onAdd={this.addToBasket}
                  />
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    );

  }

}

export default connect(
  (state, { studentID }) => ({
    arrearsAmount: -( getStudentTotalCreditAmountToPay(state, studentID, "club_extended_services") ),
    isInBasket: getCreditTopUpAmount(state, studentID, "club_extended_services") > 0
  }),
  {
    addToBasket: addCreditTopUpToBasket,
    removeFromBasket: removeCreditTopUpFromBasket
  }
)(UnpaidClubMoneyPayment);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/UnpaidClubMoneyPayment.js